<script lang="ts">
	import { PUBLIC_STRAPI_MEDIA } from '$env/static/public'
	import type { ProductBanner } from '$lib/js/strapi/types'

	export let type: 'default' | 'product' = 'default'
	export let banner: ProductBanner
</script>

{#if banner}
	<a href="/{banner.link}"
		 class="product-banner {type}"
		 style="background-image: url('{PUBLIC_STRAPI_MEDIA}{banner.bg_img?.url}')"
	>
		<div class="product-banner__inner">
			<h2 class="product-banner__title">{banner.title}</h2>
		</div>
	</a>
{/if}


<style lang="scss">
  .product-banner {
    display: block;
    height: 100%;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;

    &__inner {
      display: flex;
      align-items: flex-end;
      height: 100%;
      background: linear-gradient(180deg, rgba(0, 0, 0, 0) 20%, rgba(0, 0, 0, 0.5) 100%);

      @media(max-width: 1024px) {
        min-height: 180px;
        background: linear-gradient(180deg, rgba(0, 0, 0, 0) 50%, rgba(0, 0, 0, 0.5) 100%);
      }
    }

    &__title {
      padding: 20px;
      margin: 0;
      color: white;

      @media (min-width: 769px) {
        font-size: 30px;
        margin: 10px;
      }
    }
  }
</style>
